import { FETCH_TENANTMANAGERLOG_REQUEST, FETCH_TENANTMANAGERLOG_SUCCESS, FETCH_TENANTMANAGERLOG_FAILURE, FETCH_TENANTMANAGERLOG_RESET, } from "../../actions";
const initialState = {
    fetchTenantManagerLog: [],
    loading: false,
    error: null,
};
const tenanatManagerLogData = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TENANTMANAGERLOG_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, fetchTenantManagerLog: action.payload });
        case FETCH_TENANTMANAGERLOG_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, fetchTenantManagerLog: null, error: null });
        case FETCH_TENANTMANAGERLOG_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, fetchTenantManagerLog: null });
        case FETCH_TENANTMANAGERLOG_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, fetchTenantManagerLog: null, error: null });
        default:
            return state;
    }
};
export default tenanatManagerLogData;
